import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { SessionMgmtService } from 'src/app/shared/services/session-mgmt/session-mgmt.service';
import { MSG_CONST } from 'src/app/shared/constants/msg-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_CONST } from 'src/app/shared/constants/app-constants';
import * as _ from 'lodash'
import { NgFor, NgClass, NgIf } from '@angular/common';
import { LitmusFeedListViewComponent } from '../../../../shared/components/litmus-feed-list-view/litmus-feed-list-view.component';
import { VerbatimHomeComponent } from '../../../../shared/components/verbatim-home/verbatim-home.component';

interface Project {
  name: string;
  noResponse: number;
  lastView: Date;
}

@Component({
    selector: 'app-account-inbox-home',
    templateUrl: './account-inbox-home.component.html',
    styleUrls: ['./account-inbox-home.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        NgFor,
        NgClass,
        NgIf,
        LitmusFeedListViewComponent,
        VerbatimHomeComponent,
    ]
})
export class AccountInboxHomeComponent {
  tabs:any=[]

  activeTab:any={
    name:"All responses",
    key:"all_responses"
  }
  allResponse:any = {
    name:"All responses",
    key:"all_responses"
  }
  priorityInbox:any = {
      name:"Priority inbox",
      key:"priority_inbox"
    }
  verbtim:any = {
    name:"Verbatim",
    key:"verbatim"
  }
  // projects will receive from Api data
  projects: Project[] = [
    {
      "name": "ECSAT FS WO Completed ",
      "noResponse": 1,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 2,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 3,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 4,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 5,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 6,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()

    }
    ,
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 7,
      "lastView": new Date()
    },
    {
      "name": "ECSAT FS WO Completed ",
      "noResponse": 1,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 2,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 3,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed ",
      "noResponse": 1,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 2,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 3,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed ",
      "noResponse": 1,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 2,
      "lastView": new Date()

    },
    {
      "name": "ECSAT FS WO Completed",
      "noResponse": 3,
      "lastView": new Date()

    },
  ];

  constructor(
    private AccountsService: AccountsService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,

  ) {
    translate.setDefaultLang('en');
    translate.use('en');

  }
  ngOnInit() {
    if(Helpers.isTabVisible(true,'inbox','all_responses')){
      this.tabs.push(this.allResponse)
    }
    if(Helpers.isTabVisible(true,'inbox','verbatim')){
      this.tabs.push(this.verbtim)
    }
    
    this.activeTab = (this.tabs && this.tabs.length)?this.tabs[0]:{};
    this.route.queryParams.subscribe((param:any)=>{
      const tabname = param.active_tab;
      if(tabname){
        this.activeTab = _.find(this.tabs,{key:tabname})
      } else{
       this.changeTab(this.activeTab)
      }
    })
  }

  changeTab(tab:any){
    this.activeTab = tab;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: this.activeTab.key },
      queryParamsHandling: 'merge'
    });
  }
}

